import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-paymentfail',
  templateUrl: './paymentfail.component.html',
  styleUrls: ['./paymentfail.component.css']
})
export class PaymentfailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
